import {seoContentMapEn} from "./lang/en";
import {seoContentMapZh} from "./lang/zh";
import {seoContentMapJa} from "./lang/ja";
import {seoContentMapDe} from "./lang/de";
import {seoContentMapKo} from "./lang/ko";
import {seoContentMapRu} from "./lang/ru";
import {seoContentMapEs} from "./lang/es";
import {defaultKeywords} from "./keywords";

export const seoContentMap = {
    en: seoContentMapEn,
    zh: seoContentMapZh,
    ja: seoContentMapJa,
    de: seoContentMapDe,
    ko: seoContentMapKo,
    es: seoContentMapEs,
    ru: seoContentMapRu
};

export const rodinBrandInfo = {
    en: " - 3D model by Rodin Hyper3D",
    zh: " - 3D 模型由 Rodin Hyper3D 提供",
    de: " - 3D-Modell von Rodin Hyper3D",
    ja: " - Rodin Hyper3D による 3Dモデル",
    ko: " - Rodin Hyper3D의 3D 모델",
    es: " - Modelo 3D de Rodin Hyper3D",
    ru: " - 3D-модель от Rodin Hyper3D",
};

export const chatAvatarBrandInfo = {
    en: " - 3D model by ChatAvatar Hyper3D",
    zh: " - 3D 模型由 ChatAvatar Hyper3D 提供",
    de: " - 3D-Modell von ChatAvatar Hyper3D",
    ja: " - ChatAvatar Hyper3D による 3Dモデル",
    ko: " - ChatAvatar Hyper3D의 3D 모델",
    es: " - Modelo 3D de ChatAvatar Hyper3D",
    ru: " - 3D-модель от ChatAvatar Hyper3D",
};

export const defaultRodinModelKeywords = {
    en: defaultKeywords
}

export const modelPagePresetDescription = {
    en: "Free 3D models ready to view and download in fbx, obj, glb and usd. For games, VR/AR, video production, and 3D printing.",
    zh: "免费 3D 模型，可在 fbx、obj、glb 和 usd 格式中查看和下载。适用于游戏、VR/AR、视频制作以及 3D 打印。",
    de: "Kostenlose 3D-Modelle, die in fbx, obj, glb und usd bereitstehen – zum Anzeigen und Herunterladen. Für Spiele, VR/AR, Videoproduktionen und 3D-Druck.",
    ja: "fbx、obj、glb、usd 形式で閲覧・ダウンロードできる無料の 3D モデルです。ゲーム、VR/AR、映像制作、そして 3D プリントに最適です。",
    ko: "무료 3D 모델로 fbx, obj, glb, usd 형식으로 미리보기 및 다운로드가 가능합니다. 게임, VR/AR, 비디오 제작 및 3D 프린팅에 활용할 수 있습니다.",
    es: "Modelos 3D gratuitos listos para ver y descargar en fbx, obj, glb y usd. Para juegos, VR/AR, producción de video e impresión 3D.",
    ru: "Бесплатные 3D-модели, доступные для просмотра и скачивания в форматах fbx, obj, glb и usd. Подходят для игр, VR/AR, видеопроизводства и 3D-печати.",
};
